import { getProduct } from '../../product-catalog/productPresentation';
import HiCPSIntroPage from './HiCPSIntroPage';
import PGSolutionIntroPage from './PGSolutionIntroPage';
import HiLinkIntroPage from './HiLinkIntroPage';

export const productPages = [
  { product: getProduct('hi-cps'), Component: HiCPSIntroPage },
  { product: getProduct('pg-solution'), Component: PGSolutionIntroPage },
  { product: getProduct('hi-link'), Component: HiLinkIntroPage },
];
